module.exports = __webpack_public_path__ + "static/media/mouthUpperUpRight.71badb06.obj";